export const PAGES_ROUTE_NAMES = {
  ROOT: 'pages',
  MISSION: 'mission',
  DASHBOARD: 'dashboard',
} as const;
